module.exports = __webpack_public_path__ + "img/18.d5243bfc.png";